import { useState, useEffect } from "react";

export interface Size {
  width?: number;
  height?: number;
}

const getWindowSize = (): Size =>
  typeof window === "undefined"
    ? { width: undefined, height: undefined }
    : { width: window.innerWidth, height: window.innerHeight };

export default function useWindowSize(): Size {
  const [windowSize, setWindowSize] = useState<Size>(getWindowSize);

  useEffect(() => {
    const handleResize = () => setWindowSize(getWindowSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
